import React, { useState } from 'react';
import { Table } from 'antd';
import { Breadcrumb, Heading, ContentDropDown } from '../common/atoms';
import { SearchBarCard } from '../common/organisms';
import { employeeDataApi } from '../../services';
import { handleAppError } from '../handlers';
import { PngExportFrame } from '../opdClaims/primitives';
import { updateTableSchema as schema } from '../../schemas/table';
import { FAQS } from '../../constants/employeeData';

const UpdateEmployeesPage = ({ history }) => {
  const [data, setData] = useState(null)
  const [localstate, setLocalState] = useState({ emailValue: '', empcodeValue: ''})

  const editHandler = (data) => {
    history.push('/update-employees/edit', { data: JSON.stringify(data) });
  };

  const searchAction = async (value = '', perPage = 0) => {
    const options = { params: { page : perPage, q: value } };

    employeeDataApi.search_employees(
      options,
      (res) => {
        onSearchSuccess(res);
      },
      (error) => handleAppError(error)
    );
  };

  const onSearchSuccess = (result) => {
    let data = result.data.meta?.customers.map((element, index) => {
      return {
        key: index + 1,
        ...element,
        handler: editHandler,
      };
    });

    data = data.length > 0 ? data : null;

    setData(data);
  };

  const searchValueHandler = (ind, value) => {
    let newstate = {}
    if(ind === 0) newstate = {emailValue: value, empcodeValue: ''}
    if(ind === 1) newstate = {emailValue: '', empcodeValue: value}

    setLocalState({...newstate})
  }

  return (
    <React.Fragment>
      <Breadcrumb
        list={[
          { text: 'Manage Employees', link: '/employee-registration' },
          { text: 'Update Employees', link: '/update-employees' },
        ]}
        classes='mb-1'
      />
      <Heading mainHeading='Update Employees' />
      <SearchBarCard
        onValueChange={searchValueHandler}
        searchAction={searchAction}
        heading='Update Employees'
        description='You can update employee details by searching the employee.'
        searchList={['Search by email address', 'Search by employee code']}
        searchValues={[localstate.emailValue, localstate.empcodeValue]}
        classes='mt-8'
      />
      {data && (
        <div className='mt-8 px-4'>
          <h1 className='text-gray-500 text-base font-semibold mb-3'>Search Results</h1>
          <PngExportFrame fileName='employee-search-results'>
            <Table className='ant-table-body' style={{ boxShadow: 'none', borderRadius: '3px', color: '#e5e8f0' }} pagination={false} columns={schema} dataSource={data} />
          </PngExportFrame>
        </div>
      )}

      <div className='flex mt-12'>
        <div className='w-1/2'>
          <h1 className='text-lg font-semibold text-gray-700'>Frequently asked questions</h1>
          <p className='mb-0 mt-2 text-gray-600'>Can’t find the answer you’re looking for?</p>
          <p className='mb-0 text-gray-600'>
            Reach out to our <span className='font-semibold text-blue-500'>customer success manager.</span>
          </p>
        </div>
        <div className='w-1/2'>
          {FAQS['update'].map((item, ind) => {
            return <ContentDropDown key={item.title} {...item} classes={ind === 0 ? '' : 'mt-6'} />;
          })}
        </div>
      </div>
    </React.Fragment>
  );
};

export default UpdateEmployeesPage;
